import React from 'react';
import styles from './Table.module.scss';

const Td = ({ children, ...props }) => {
  return (
    <td className={styles.Td} {...props}>
      {children}
    </td>
  );
};

export default Td;
